import React from 'react'
import { v4 as uuidv4 } from 'uuid'
import styled from '@emotion/styled'
import ProjectCard from './ProjectCard/ProjectCard'
import { Container } from '@mui/system'
import { Grid, Typography } from '@mui/material'
import { projects } from '../../data/data'
import DryCleaningIcon from '@mui/icons-material/DryCleaning';

const ClientesContainer = styled(Container)`
  text-align: center;
  margin: 100px 0 100px 0;
  padding-top: 100px;
`

const ProjectGridItem = styled(Grid)`
  display: flex;
  justify-content: center;
  align-content: center;
`

const Clientes = () => {
  return (
    <ClientesContainer id="Clientes-Container">
      <DryCleaningIcon sx={{ fontSize: 40 }}/>
      <Typography variant="h1" sx={{ marginBottom: 2 }}>
        Nuestros Clientes
      </Typography>
      <Grid container spacing={2} id="Clientes-Grid">
        {projects.map((project) => (
          <ProjectGridItem item xs={12} md={6} key={uuidv4()}>
            <ProjectCard {...project} />
          </ProjectGridItem>
        ))}
      </Grid>
    </ClientesContainer>
  )
}

export default Clientes
